<style scoped>
.br-12 {
  border-radius: 12px;
}
</style>

<template>
  <div class="pa-3">
    <v-layout row wrap justify-center v-if="isLoading || services.length === 0">
      <v-flex xs12 sm6 md6 lg4 xl3 pa-1 v-for="i in 10" :key="i">
        <v-skeleton-loader class="mx-auto" max-width="300" type="card"></v-skeleton-loader>
      </v-flex>
    </v-layout>
    <v-layout row wrap justify-center v-if="!isLoading && services.length > 0">
      <v-flex xs12 sm6 md6 lg4 xl3 pa-1 v-for="(service, i) in services" :key="i">
        <v-card @click.native="service.coming_soon ? '' : routes(service.route)">
          <div style="position: absolute; z-index: +1;" v-if="service.new">
            <img src="img/cards/new.png">
          </div>
          <div style="position: absolute; z-index: +1;" v-if="service.coming_soon">
            <img src="img/cards/coming-soon.png">
          </div>

          <v-img class="white--text" height="100%" :src="`img/cards/${service.image}`">
            <v-layout fill-height>
              <v-layout align-end d-flex>
                <div style="background-color: black; opacity: 0.65; width: 100%">
                  <span class="pa-3 d-flex xs12 headline">{{ $t(service.label) }}</span>
                </div>
              </v-layout>
            </v-layout>
          </v-img>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import axios from '../axios'
import configurations from '../configurations'

export default {
  data: () => ({ isLoading: false, services: [] }),
  mounted () {
    this.fetchServices()
  },
  methods: {
    async fetchServices () {
      this.isLoading = true
      try {
        const { data } = await axios({
          url: `${configurations.WORKER}/query`,
          method: 'POST',
          data: {
            url: btoa('/metadata/configuration')
          }
        })
        this.services = data.services
      } catch (error) {
        this.$store.dispatch('snackbar/setSnackBar', { color: 'error', message: `Failed to load. Please check whether you have internet connection.`, visible: true })
      } finally {
        this.isLoading = false
      }
    },
    routes: function (category) {
      let page
      if (category === 'mdkguweb') {
        page = configurations.host.mdkguweb
        if (!window.hasOwnProperty('cordova')) {
          window.open(page)
          return
        }

        cordova.InAppBrowser.open(page, '_system', 'location=no,enableViewportScale=yes,zoom=no')
        return
      }

      if (category === 'pay') {
        page = configurations.host.mdkgupay
        if (!window.hasOwnProperty('cordova')) {
          window.open(page)
          return
        }

        cordova.InAppBrowser.open(page, '_system', 'location=no,enableViewportScale=yes,zoom=no')
        return
      }

      if (category === 'sabahgoverement') {
        page = configurations.host.SABAH_GOV_WEB
        if (!window.hasOwnProperty('cordova')) {
          window.open(page)
          return
        }

        cordova.InAppBrowser.open(page, '_system', 'location=no,enableViewportScale=yes,zoom=no')
        return
      }

      if (category === 'updateAssessmentOwnership') {
        return this.$router.push({ path: 'ticket/form', query: { ticket: 'UDCT' } })
      }

      return this.$router.push(category)
    }
  }
}
</script>
